import { FormProvider, UseFormReturn } from 'react-hook-form';
import { LoadingIndicator } from '../loading-indicator.component';
import { useSnackbar } from '../../hooks/use-snackbar.hook';
import { parseErrorMessageRecursive } from '../../utils/yup-error-parser.util';

interface ReactHookFormProps {
  onSubmit: (values: any) => any;
  children: any;
  formName: string;
  formContextProps: UseFormReturn;
  isBusy?: boolean;
}

export const ReactHookForm = ({ onSubmit, children, formName, formContextProps, isBusy }: ReactHookFormProps): any => {
  const { showSnackbar } = useSnackbar();

  const handleKeyDown = (e: any) => {
    if (e.code === 'Space') {
      e.stopPropagation();
    }
    if (e.code === 'Enter') {
      // formContextProps.handleSubmit(onSubmit)();
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const handleError = (error: any) => {
    const messages = parseErrorMessageRecursive(error);
    const errorCount = messages?.length > 1 ? ` | +${messages.length - 1} more` : '';
    // showSnackbar(`Validation Error: ${messages[0]} ${errorCount}`, 'error');
    // showSnackbar(`Validation Error: ${messages?.map((message) => message)} `, 'error');

    let requiredMessages: any[] = [];
    let otherMessages: any[] = [];

    // Classify messages
    Array.isArray(messages) &&
      messages?.forEach((message) => {
        if (message.endsWith('is required')) {
          requiredMessages.push(message?.split(' is required')[0]?.trim());
        } else {
          otherMessages.push(message.trim());
        }
      });

    // Remove duplicates
    requiredMessages = Array.from(new Set(requiredMessages));
    otherMessages = Array.from(new Set(otherMessages));

    // Construct the final message
    const finalRequiredMessage = requiredMessages.length > 0 ? `${requiredMessages?.join(', ')} is required` : '';
    const finalOtherMessage = otherMessages?.join(', ');

    // Combine messages
    const finalMessage = [finalRequiredMessage, finalOtherMessage]?.filter(Boolean)?.join(', ');

    // Show the final formatted message
    showSnackbar(`Validation Error: ${finalMessage}`, 'error');
  };

  return (
    <FormProvider {...formContextProps}>
      <LoadingIndicator isLoading={isBusy} isSpinner />
      <form onSubmit={formContextProps.handleSubmit(onSubmit, handleError)} id={formName} onKeyDown={handleKeyDown}>
        {children}
      </form>
    </FormProvider>
  );
};
